import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import Config from '../../app.config';
import PageHeading from '../../components/PageHeading';
import SqzText from '../../components/SqzText';
import Footer from '../../containers/Footer';
import Header from '../../containers/Header';
import '../../css/how-it-works.css';
import { analytics } from '../../utils/common';

export default function HowItWorks(props) {
  analytics('How it Works');
  return (
    <div>
      <Helmet titleTemplate="%s - Squeeze" defaultTitle="Squeeze">
        <title>Booking an Appointment in a Snap | Squeeze Massage</title>
        <meta
          name="description"
          content="Use the Squeeze app to book by location or therapist. You can also pay on the app &amp; tip as you please. No cashiers, no worries. Book an appointment today."
        />
         <meta
          name="keywords"
          content="how it works, Squeezemassage, booking, relaxation, massage app"
        />
      </Helmet>
      <Header
        showCloseButton={false}
        showBackButton={false}
        showHamburgerMenu
      />
      <div className="multiple-header-font howit-works-page">
        <header className="headerTitle">
          <PageHeading mobileTitle="HOW SQUEEZE WORKS">
            A Way Better
          </PageHeading>
          <PageHeading mobileTitle="HOW SQUEEZE WORKS">
            Massage Experience.
          </PageHeading>
          <SqzText addClass="smallFontHowItWork phone-only hiwHeader">
            A WAY BETTER MASSAGE EXPERIENCE
          </SqzText>
          <div className="hiw-subheader">
            <h3 className="hiw-subhdg">{"Here's"} Why:</h3>
          </div>
        </header>
      </div>

      <section className="hiw container">
        <div className="hiw-details">
          <div className="hiw-item hiw-item--1">
            <i className="icon icon--squiggle phone-only" />
            <div className="hiw-item__image">
              <div className="hiw-item hiw-item__ir-1 ir">
                <img
                  src={`${
                    Config.awsCloudFrontUrl
                  }/images/how-it-works/app-book-2023.png`}
                  alt="Booking on the Squeeze App"
                />
              </div>
            </div>
            <div className="hiw-item__text">
              <i className="icon icon--squiggle squiggle-top hide-phone" />
              <div className="hiw-item__text-inner">
                <h4 className="hiw-item__hdr">
                  BOOK IN A SNAP<br />
                  <span>ON OUR APP.</span>
                </h4>
                <p className="hiw-item__content">
                  Book by location or with your favorite therapist. It’s
                  easy-peasy, Squeezy.
                </p>
              </div>
              <i className="icon icon--squiggle squiggle-bottom hide-phone" />
            </div>
          </div>
          <div className="hiw-item hiw-item--2 hiw-item--alt">
            <i className="icon icon--squiggle phone-only" />
            <div className="hiw-item__image">
              <div className="hiw-item hiw-item__ir-2 ir">
                <img
                  src={`${
                    Config.awsCloudFrontUrl
                  }/images/how-it-works/preferences.png`}
                  alt="Massage preferences"
                />
              </div>
            </div>
            <div className="hiw-item__text">
              <i className="icon icon--squiggle squiggle-top hide-phone" />
              <div className="hiw-item__text-inner">
                <h4 className="hiw-item__hdr">
                  YOU MIGHT THINK<br />
                  <span>WE’RE MIND READERS.</span>
                </h4>
                <p className="hiw-item__content">
                  But we’re not. We just save your massage preferences to your
                  profile, so your therapist knows exactly what you want, each
                  and every time.
                </p>
              </div>
              <i className="icon icon--squiggle squiggle-bottom hide-phone" />
            </div>
          </div>

          <div className="hiw-item hiw-item--3">
            <i className="icon icon--squiggle phone-only" />
            <div className="hiw-item__image">
              <div className="hiw-item hiw-item__ir-3 ir">
                <img
                  src={`${
                    Config.awsCloudFrontUrl
                  }/images/how-it-works/aromatherapy.png`}
                  alt="Aromatherapy"
                />
              </div>
            </div>
            <div className="hiw-item__text">
              <i className="icon icon--squiggle squiggle-top hide-phone" />
              <div className="hiw-item__text-inner">
                <h4 className="hiw-item__hdr">
                  <span>EXTRAS</span> DON’T <br />COST EXTRA.
                </h4>
                <p className="hiw-item__content">
                  Each massage includes your choice of deep tissue, heat
                  therapy, percussion therapy and aromatherapy at no additional
                  charge.
                </p>
              </div>
              <i className="icon icon--squiggle squiggle-bottom hide-phone" />
            </div>
          </div>

          <div className="hiw-item hiw-item--4 hiw-item--alt">
            <i className="icon icon--squiggle phone-only" />
            <div className="hiw-item__image">
              <div className="hiw-item hiw-item__ir-4 ir">
                <img
                  src={`${
                    Config.awsCloudFrontUrl
                  }/images/how-it-works/ipad.png`}
                  alt="iPad"
                />
              </div>
            </div>
            <div className="hiw-item__text">
              <i className="icon icon--squiggle squiggle-top hide-phone" />
              <div className="hiw-item__text-inner">
                <h4 className="hiw-item__hdr">
                  CONTROL FREAK?<br />
                  <span>NO PROBLEM.</span>
                </h4>
                <p className="hiw-item__content">
                  Set your own music and lighting, and let your therapist know
                  when to re-enter using the “ready button.”
                </p>
              </div>
              <i className="icon icon--squiggle squiggle-bottom hide-phone" />
            </div>
          </div>

          <div className="hiw-item hiw-item--5 pb50">
            <i className="icon icon--squiggle phone-only" />
            <div className="hiw-item__image">
              <div className="hiw-item hiw-item__ir-5 ir">
                <img
                  src={`${
                    Config.awsCloudFrontUrl
                  }/images/how-it-works/app-tips-2023.png`}
                  alt="Pay on the App"
                />
              </div>
            </div>
            <div className="hiw-item__text">
              <i className="icon icon--squiggle squiggle-top hide-phone" />
              <div className="hiw-item__text-inner">
                <h4 className="hiw-item__hdr">
                  IT’S APP-SOLUTELY<br />
                  <span>STRESS FREE.</span>
                </h4>
                <p className="hiw-item__content">
                  No cashiers. No annoying checkout. You pay on the app, then
                  tip and review at your leisure. So after your massage, you
                  walk right on out.
                </p>
              </div>
              <i className="icon icon--squiggle squiggle-bottom hide-phone" />
            </div>
          </div>
        </div>

        {!props.showFooter && (
          <div className="hiw-cta">
            <div className="hiw-cta__spacer desktop-and-tablet" />
            <div className="hiw-cta__content">
              <div className="hiw-cta__content-inner">
                <h4 className="hiw-cta__hdg">{"Let's"} get you started!</h4>
                <NavLink
                  aria-label="book-massage"
                  to="/appointment/locations"
                  className="hiw-cta__btn btn"
                  onClick={() => {
                    analytics('Home - Book a Massage', null, true);
                  }}
                >
                  Book A Massage
                </NavLink>
              </div>
            </div>
          </div>
        )}
      </section>

      {!props.showFooter && <Footer />}
    </div>
  );
}

HowItWorks.propTypes = {
  showFooter: PropTypes.bool,
};
